import { render, staticRenderFns } from "./BtnPagoNotaCredito.vue?vue&type=template&id=19b7f6a8&"
import script from "./BtnPagoNotaCredito.vue?vue&type=script&lang=js&"
export * from "./BtnPagoNotaCredito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports